// App-wide: open the native date picker when the user clicks anywhere in a
// date field (or presses Enter / Space on it), not only on the small calendar
// icon. Uses the built-in HTMLInputElement.showPicker() - no library. Browsers
// without it simply keep their default behaviour.

const PICKER_INPUT_TYPES = new Set(["date", "datetime-local", "month"]);

function isPickerInput(el) {
  return (
    el instanceof HTMLInputElement &&
    PICKER_INPUT_TYPES.has(el.type) &&
    !el.disabled &&
    !el.readOnly
  );
}

function openPicker(input) {
  try {
    input.showPicker?.();
  } catch (e) {
    // Ignore: e.g. the picker is already open.
  }
}

export function enableDatePickerOnClick() {
  document.addEventListener("click", (event) => {
    if (isPickerInput(event.target)) openPicker(event.target);
  });

  document.addEventListener("keydown", (event) => {
    if (
      (event.key === "Enter" || event.key === " ") &&
      isPickerInput(event.target)
    ) {
      event.preventDefault();
      openPicker(event.target);
    }
  });
}
